import ConditionView from './src/conditionView.vue';

/* istanbul ignore next */
ConditionView.install = function(Vue) {
    Vue.component(ConditionView.name, ConditionView);
};

export default ConditionView;